<template>
    <div class="user-management-wrapper">
        <h2>User Management</h2>
        <hr>
        <div class="d-flex justify-content-between mb-2">
            <div class="btn btn-secondary cursor" @click="$router.back()">Back</div>
            <div class="btn btn-primary cursor" @click="loadNewUserModal">Add User</div>
        </div>
        <div class="user-management">
            <BasicDataGrid
                    :dataSource="users"
                    :dataGridKey="dataGridKey"
                    :columns="columns"
                    :multiSelect="false"
                    :showColumnLines="false"
                    :actions="actions"
                    v-on:editUser="loadEditUserModal"
            />
        </div>
        <Modal ref="userModal">
            <DealerUsersEdit :user="tempUser"
                             :users="users"
                             :groups="groups"
                             v-on:update:success="handleDealerUserUpdateSuccess" />
        </Modal>
    </div>

</template>

<script>
    import { mapState }     from 'vuex';

    import { DealerService }    from '@/services';
    import BasicDataGrid    from '@/components/BasicDataGrid.vue';
    import DealerUsersEdit  from '@/views/dashboard/tenants/DealerUsersEdit.vue';

    import {
        getKeyByValue,
        userRoleEnum
    }                       from "../../../modules/helpers";

    // import axios from 'axios'
    // const dataSource = createStore({
    //     key: 'Id',
    //     loadUrl: DealerService.allDX(),
    //     onBeforeSend: (method, ajaxOptions) => {
    //         console.log('ajaxOptions', ajaxOptions)
    //         ajaxOptions.xhrFields = { withCredentials: true };
    //         ajaxOptions.headers = {Authorization: axios.defaults.headers.common['Authorization']}
    //     }
    // });

    export default {
        name: "DealerUsers",
        components: {
          BasicDataGrid,
          DealerUsersEdit,
        },
        data: () => {
            return {
                actions: [
                    {
                        hint: 'Edit',
                        icon: 'edit',
                        emit: 'editUser',
                    },
                ],
                columns: [
                    { text: 'First Name', value: 'FirstName'   },
                    { text: 'Last Name' , value: 'LastName'    },
                    { text:  'Role', value: 'UserRole'},
                    { text: 'Sales Manager' , value: 'SalesManager'    },
                    { text: 'Groups' , value: 'GroupNames'    },
                ],
                users: [],
                groups: [],
                tempUser: {},
                dataGridKey: 'AppUserId',
            }
        },
        computed: {
            ...mapState(['currentUser'])
        },
        methods: {
            getDealerUsers(){
                let dealerId = this.$route.params.id;
                DealerService.currentUserSubordinates(dealerId).then(res => {
                    this.users = res;
                }).catch(err => {
                    this.$store.dispatch('ADD_NOTIFICATION', { text: err.response.data.Message , type: 'error' });
                })
            },
            getDealerGroups(){
                let dealerId = this.$route.params.id;
                DealerService.groups(dealerId).then(res => {
                    this.groups = res;
                }).catch(err => {
                    this.$store.dispatch('ADD_NOTIFICATION', { text: err.response.data.Message , type: 'error' });
                })
            },
            loadNewUserModal(){
                this.clearTempUser();
                this.$refs.userModal.openModal();
            },
            loadEditUserModal(e){
                let user = {...e.row.data};
                this.clearTempUser();
                this.tempUser = user;
                this.$refs.userModal.openModal();
            },
            clearTempUser(){
                this.tempUser = defaultUser();
            },
            handleDealerUserUpdateSuccess(){
                this.closeModal();
                this.getDealerUsers();
            },
            closeModal(){
                // this.tempUser = defaultUser();
                this.$refs.userModal.closeModal();
            }
        },
        mounted(){
            this.getDealerUsers();
            this.getDealerGroups();
        },
    }

    function defaultUser() {
        return {
            FirstName: '',
            LastName:  '',
            MobilePhone: '',
            Email: '',
            AddressLine1 : '',
            AddressLine2 :  '',
            City: '',
            StateProvinceId : null,
            ZipCode : null,
            UserRoleId: null,
            ManagerId: null,
            GroupIds: [],
        }
    }
</script>

<style scoped lang="scss">
    .user-management-wrapper {
        // max-width: 1800px;
    }
</style>
